import { X, AlertTriangle } from "lucide-react";
import useTitanApp from "@/hooks/useTitanApp";

interface ErrorConsultationModalProps {
  open: boolean;
  onClose: () => void;
}

export default function ErrorConsultationModal({ open, onClose }: ErrorConsultationModalProps) {
  const { appState } = useTitanApp();
  const { darkMode } = appState || {};
  if (!open) return null;

  return (
    <div
      className="fixed inset-0 custom-zindex flex items-center justify-center backdrop-blur-sm bg-black/40"
      onClick={onClose}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        className={`
          relative w-full max-w-md p-6 rounded-2xl shadow-xl
          ${darkMode ? "bg-gray-900 text-white" : "bg-white text-gray-900"}
        `}
      >
        {/* Close Button */}
        <button
          onClick={onClose}
          className="absolute top-4 right-4 text-gray-400 hover:text-gray-600 transition-colors"
        >
          <X className="w-5 h-5" />
        </button>

        {/* Warning Icon */}
        <div className="flex flex-col items-center justify-center space-y-4 py-6">
          <AlertTriangle className="w-12 h-12 text-red-500" />
          <p className="text-xl font-semibold text-red-600 text-center">
            Error Processing Consultation
          </p>
          <p className="text-center text-gray-600">
            Something went wrong while processing your consultation. Please try again.
          </p>
        </div>

        {/* OK Button */}
        <div className="flex justify-center mt-4">
          <button
            onClick={onClose}
            className={`
              px-6 py-2 rounded-lg font-medium 
              bg-black text-white hover:bg-gray-800
              transition-colors
            `}
          >
            OK
          </button>
        </div>
      </div>
    </div>
  );
}
